export default "__VITE_ASSET__BT5Qed6n__"